
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { ComposerModule } from '@acaprojects/ngx-composer';
import { WidgetsModule } from '@acaprojects/ngx-widgets';

import { OverlayComponentModule } from './overlays/overlays.module';
import { SharedComponentModule } from './shared/components/shared.module';

import { AppComponent } from './app.component';
import { APP_COMPONENTS, APP_ENTRY_COMPONENTS } from './shell';
import { ROUTES } from './app.routes';
import { environment } from '../environments/environment';

import './shared/mock';
import { DropPointDirective } from './shared/directives/drop-point.directive';
import { AMapFeature } from '@acaprojects/ngx-interactive-map';

@NgModule({
    declarations: [
        AppComponent,
        ...APP_COMPONENTS,
        ...APP_ENTRY_COMPONENTS,
        DropPointDirective
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        RouterModule.forRoot(ROUTES, { useHash: true }),
        HttpClientModule,
        FormsModule,
        ServiceWorkerModule.register('__base__ngsw-worker.js', { enabled: environment.production }),
        WidgetsModule.forRoot(),
        ComposerModule,
        OverlayComponentModule,
        SharedComponentModule,
        DragDropModule
    ],
    providers: [
        { provide: AMapFeature }
     ],
    entryComponents: [
        ...APP_ENTRY_COMPONENTS,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
